import { Typography } from 'antd';
import Image from 'next/image';
import React from 'react';

import BookList from './Booklist';
import { LineLarge } from '../../../../assets';
import { books } from '../../../utils/data';

const BookLibrary: React.FC = () => {
  return (
    <div>
      <div className=' pt-10  px-4 lg:px-24 lg:pt-16 xl:pt-32'>
        <div className='flex flex-col text-center gap-y-2'>
          <span className='font-bold flex justify-center text-2xl xl:text-[36px]'>
            <div className='flex flex-col text-center sm:whitespace-nowrap xl:leading-10 text-fadedWhite'>
              <span className='font-bold md:w-min wh'>
                Explore Our Bestsellers
                <div className='w-fit hidden md:flex '>
                  <Image
                    src={LineLarge}
                    alt='LineLarge'
                    className='object-contain w-full h-full'
                  />
                </div>
              </span>
            </div>
          </span>
          <span className='text-center xl:text-[20px] flex justify-center text-textGray'>
            <Typography.Title level={3} className='md:w-2/5 text-fadedWhite'>
              Zebralearn’s books are built on the <b>“Learn-by-doing”</b>{' '}
              concept. “DO” the things you are learning instead of just
              “READING”.
            </Typography.Title>
          </span>
        </div>
        {/* <HeadingV2 heading='Explore Our Bestsellers' /> */}
      </div>
      <div className='py-10 md:py-2'>
        <BookList books={books} />
      </div>
    </div>
  );
};

export default BookLibrary;
